module.exports = __webpack_public_path__ + "static/media/icon-people.d004d474.svg";